/**
 * 100vh用のCSS変数
 */
export default class CustomPropertyManager {
  addressBarHeight = 0;

  windowHeight;

  constructor() {
    // アドレスバーの高さ計算用の要素を取得
    const heightController = document.getElementById('js-height-controller');

    // アドレスバーの高さを計算する
    this.addressBarHeight = Math.abs(window.innerHeight - heightController.clientHeight);

    this.initViewport();
    this.setResizeEvent();
  }

  isFacebookApp() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1);
  }

  isiOS() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
  }

  initViewport() {
    var vh = (document.documentElement.clientHeight + this.addressBarHeight) / 100;

    var root = document.documentElement;

    root.style.setProperty('--const-vh', vh + 'px');
    root.style.setProperty('--vh', vh + 'px');
    root.style.setProperty('--const-address-bar-height', this.addressBarHeight + 'px');

    //
    root.style.setProperty('--home-bg-vh', vh + 'px');

    this.updateViewport();
  }

  setResizeEvent() {
    const self = this;

    window.addEventListener('resize', function () {
      self.updateViewport();
    });

    // デバイス回転時
    window.addEventListener('orientationchange', function () {
      self.orientationChangeViewport();
    });
  }

  updateViewport() {
    var vh = (document.documentElement.clientHeight + this.addressBarHeight) / 100;

    // Facebookアプリ内蔵ブラウザの場合はscreen.heightを使用する
    if (this.isFacebookApp()) {
      vh = (window.screen.height) / 100;
    }

    var vw = window.innerWidth / 100;

    var root = document.documentElement;

    // 各カスタムプロパティに`window.innerHeight / 100`,`window.innerWidth / 100`の値をセット

    // 可変アドレスバーが存在しない場合はvhをレスポンシブ対応
    // 可変アドレスバーがある場合は表示がおかしくなるため対応しない。
    if (0 == this.addressBarHeight) {
      /**
       * iOSのInstagramやTwitterのアプリ内ブラウザは可変アドレスバーの高さが取得できないため、ウィンドウ幅も考慮する
       */
      if (window.innerWidth >= 751) {
        // モバイル以外のレイアウトならvhをレスポンシブ対応
        root.style.setProperty('--vh', vh + 'px');
      }
    }

    if (vh > vw) {
      root.style.setProperty('--vmax', vh + 'px');
      root.style.setProperty('--vmin', vw + 'px');
    } else {
      root.style.setProperty('--vmax', vw + 'px');
      root.style.setProperty('--vmin', vh + 'px');
    }
  }

  orientationChangeViewport() {
    // ネイティブPAIの高さの取得タイミングが遅いため、setTimeoutで遅延させる
    setTimeout(function () {
      var vh = (document.documentElement.clientHeight + this.addressBarHeight) / 100;
      var root = document.documentElement;

      root.style.setProperty('--vh', vh + 'px');
      // 背景動画用のvh
      root.style.setProperty('--home-bg-vh', vh + 'px');
    }.bind(this), 100);
  }
}
